module.exports = __webpack_public_path__ + "img/logo.1ccaf7d2.png";